import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import OtpInput from 'react-otp-input'

import { COLORS } from 'app/constants'
import { useWindowDimensions } from 'app/hooks'
import { View } from 'styles/reactnative'

import API from '../../../../utils/api'
import { goTo } from '../../../hooks/navigation'
import { useToken } from '../../../hooks/'

const VerifyCode = ({ authSuccess, setAuthSuccess, setVerifyError }) => {
	const navigate = useHistory()
	const { width } = useWindowDimensions()
	const { mutate } = useToken('', true)
	const [code, setCode] = useState('')

	const handleVerification = async () => {
		if (authSuccess) {
			if (code.length === 6) {
				const res = await API.postPublic('/auth/verifycode', {
					verifyid: authSuccess,
					code: code,
				})
				if (res.result !== false) {
					mutate(res.result)
					goTo(navigate, '/')
					setAuthSuccess('')
					setVerifyError(false)
				}
				if (res.result === false) {
					setVerifyError(true)
				}
			}
		}
	}
	const handleChange = (otp: string) => setCode(otp)

	useEffect(() => {
		handleVerification()
		if (code.length === 0) {
			setVerifyError(false)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [code, setVerifyError])

	const inputSize =
		width < 900 ? 50 : width < 1150 ? 38 : width < 1300 ? 42 : 48
	return (
		<View
			style={{ alignItems: 'flex-start', width: '100%', marginTop: 10 }}>
			<OtpInput
				value={code}
				onChange={handleChange}
				numInputs={6}
				containerStyle={{
					height: 50,
					width: '100%',
					justifyContent: 'space-between',
				}}
				inputStyle={{
					width: inputSize,
					height: inputSize,
					borderRadius: 5,
					border: `1px solid ${COLORS.lightGray}`,
					fontSize: 30,
				}}
				hasErrored={false}
				isDisabled={false}
				focusStyle={{}}
				disabledStyle={{
					background: 'red',
				}}
				errorStyle={{
					color: 'red',
				}}
			/>
		</View>
	)
}

export default VerifyCode
